import React from "react";
import PropTypes from "prop-types";
import { useTaskCostSummary } from "~/repository";
import { CostSummary } from "./CostSummary";

export const TaskCostSummary = ({ projectId, taskId, ...rest }) => {
  const { data = {}, isFetching } = useTaskCostSummary(projectId, taskId);

  return (
    <CostSummary
      loading={isFetching}
      costByType={data?.cost_by_type}
      nonBillableExpenses={data.non_billable_expenses}
      expenses={data.expenses}
      projectId={projectId}
      totalBillable={data.billable_cost_so_far}
      totalNonBillable={data.non_billable_cost_so_far}
      totalInternal={data.internal_cost_so_far}
      withoutInternalRate={data.without_internal_rate}
      total={data.cost_so_far}
      {...rest}
    />
  );
};

TaskCostSummary.propTypes = {
  projectId: PropTypes.number.isRequired,
  taskId: PropTypes.number.isRequired,
};
